import React, { useEffect, useState } from 'react';
import CurrentAssignmentsHeader from '../../components/CurrentAssignmentsHeader';
import CurrentAssignmentsList from '../../components/CurrentAssignmentsList';
import { DashboardProvider } from '../../../dashboard/context';
import { useAssignmentContext } from '../../context';
import { useIsAssignmentsExistMutation , useSetFilterCollapseMutation } from '../../../../features/authentication/assignApiSlice';
import AssignmentSearchContent from '../../components/AssignmentSearchContent';
import AssignmentCreateContent from '../../components/AssignmentCreateContent';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { DataProvider } from '../../DataContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown,faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { useGetFiltersMutation } from '../../../../features/authentication/authApiSlice';
import { useLocation } from 'react-router';

const Layout = () => {
  const { isAssignmentsAvailable, setIsAssignmentsAvailable } = useAssignmentContext();
  const [checkAssignmentAvailable] = useIsAssignmentsExistMutation();
  const [setFilterCollapse] = useSetFilterCollapseMutation();
  const [selectedCourseName, setSelectedCourseName] = useState('');
  const [isFiltersCollapsed, setIsFiltersCollapsed] = useState(false);
  const location = useLocation();
  const [key, setKey] = useState(location?.state?.keyProp ?? 'search');
  const [getFilters] = useGetFiltersMutation();
  const [filters, setFilters] = useState(null);

  useEffect(() => {
    isAssignmentExist();
    getFiltersAsync();
  }, []);

  const isAssignmentExist = async () => {
    const response = await checkAssignmentAvailable().unwrap();
    setIsAssignmentsAvailable(response);
  };

  const setCollapseState = async (isCollapsed) => {
    const options ={
      isCollapsed:isCollapsed
    };
    await setFilterCollapse(options).unwrap();
  };

  const [assignmentBtnState] = useState({
    btns: [
      {
        id: 'tab-search',
        name: 'Search Assignment',
        key: 'search'
      },
      {
        id: 'tab-create',
        name: 'Create New Assignment',
        key: 'create'
      }
    ]
  });

  const getFiltersAsync = async () => {
    try {
      const persistFilters = await getFilters().unwrap();
      if(persistFilters !== null && persistFilters !== undefined)
      {
        setFilters(persistFilters);
        setIsFiltersCollapsed(persistFilters.isCollapsed);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <DataProvider>
        {isAssignmentsAvailable && (
          <>
            <div className='tabbed-content'>
              <Tabs
                activeKey={key}
                onSelect={(k) => setKey(k)}>
                {assignmentBtnState.btns.map((item, index) => {
                  return (                
                    <Tab
                      eventKey={item.key}
                      key={item.id + index}
                      id={item.id}
                      title={<div className={'btn-width tab-title'} >
                        {item.id === 'tab-search' ? 'Search' : 'Create New'}</div>}>
                      {item.id == 'tab-search' && <div className={`p-4 ${isFiltersCollapsed ? 'd-none':''}`}
                        id="search-content">
                        <AssignmentSearchContent
                          setSelectedCourseName={setSelectedCourseName}
                          getFilters={getFiltersAsync}
                          filters={filters}
                        />
                      </div>}
                      {item.id == 'tab-create' && <div className={`p-4 ${isFiltersCollapsed ? 'd-none':''}`}
                        id="create-content">
                        <AssignmentCreateContent showBrowseContent={true} showTitle={true} selectedCourseName={selectedCourseName} />
                      </div>}
                    </Tab>                  
                  );
                })}</Tabs>
            </div>
            <div className='align-collapsible-btn'>
              <button
                onClick={() => {setCollapseState(!isFiltersCollapsed); setIsFiltersCollapsed(!isFiltersCollapsed);}}
                className="rounded-circle z-index10 collapsible-btn">
                <FontAwesomeIcon icon={isFiltersCollapsed ? faChevronDown : faChevronUp} />
              </button>
            </div>
          </>
        )}
        <CurrentAssignmentsHeader />
        {isAssignmentsAvailable && (
          <div className="custom-table table-responsive">
            <CurrentAssignmentsList />
          </div>
        )}
      </DataProvider>
    </>
  );
};

const Assignment = () => {
  return (
    <DashboardProvider>
      <Layout />
    </DashboardProvider>
  );
};

export default Assignment;
